import { FlightEventHandler, registerEventHandlerClass } from "./flight"
import { writable } from "svelte/store"
import maxRssi from "../utils/maxRssi"
import slantDistance from "../utils/slantDistance"

const MAX_HISTORY = 50

export default class LinkStatsHistory extends FlightEventHandler {

	linkData = {}

	constructor(flight) {
		super(flight)

		const w = writable(this.history)

		this.subscribe = w.subscribe
		this.set = w.set
	}

	handleKeyframe(keyframe) {
		this.linkData = JSON.parse(JSON.stringify(keyframe.linkStats))
		this.set(this.linkData)
	}

	get isArs() {
		return true 
	}

	processMessage(message) {
		if (message.type !== 'SKYLINK_ADV_STATUS') {
			return
		}

		if (message.data.remote.protocol.radioStatus === 0) return
		if (this.isArs && !message.data.local.isLead) return
		if (!this.isArs && this.device.id !== message.data.localSource.deviceId) return

		let data = this.linkData[message.linkId]
		if (!data) {
			data = { history: getDefault() }
			this.linkData[message.linkId] = data
		}

		const dev = this.isArs ? message.data.remote : message.data.local
		data.history.rssi.push(maxRssi(dev))
		data.history.primary.push(dev.radio[0].avgRSSI)
		data.history.secondary.push(dev.radio[1].avgRSSI)
		data.history.sats.push(dev.position.gpsSatellites)
		data.history.altitude.push(dev.position.gnssAltitude)
		data.history.txBytes.push(dev.protocol.txByteTotal)
		data.history.rxBytes.push(dev.protocol.rxByteTotal)
		data.history.slant.push(slantDistance(message.data.remote, message.data.local))

		for (const key in data.history) {
			data.history[key] = data.history[key].slice(-MAX_HISTORY)
		}

		this.set(this.linkData)
	}

	handleFlightStep(message) {
		this.processMessage(message)
	}
}

function getDefault() {
	return {
		rssi: [],
		primary: [],
		secondary: [],
		sats: [],
		altitude: [],
		txBytes: [],
		rxBytes: [],
		slant: []
	}
}


registerEventHandlerClass(LinkStatsHistory)